/**
 * Home Page
 * Design: "Light with Dark Accents"
 * Hero / Navbar / Footer: Deep Navy #080C14
 * All other sections: Light #F8F9FC / #ffffff
 */
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ReferencesSection from "@/components/ReferencesSection";
import PlatformsTicker, { PlatformsTickerLight } from "@/components/PlatformsTicker";
import StatsSection from "@/components/StatsSection";
import ServicesSection from "@/components/ServicesSection";
import EducationSection from "@/components/EducationSection";
import CTASection from "@/components/CTASection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      {/* Skip-to-content for keyboard/screen reader users */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-lg focus:text-sm focus:font-semibold"
      >
        Zum Hauptinhalt springen
      </a>
      <Navbar />
      <main id="main-content">
        <HeroSection />
        <PlatformsTicker />
        <AboutSection />
        <EducationSection />
        <ReferencesSection />
        <PlatformsTickerLight />
        <StatsSection />
        <ServicesSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
